import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import { MoreFeatures } from "../../Config/features";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TilesRow from "../Tiles/tiles";

const MoreWaterMarkFeature = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row className="m-0 mt-5 pt-1 w-100 d-flex justify-content-center bgPricingFeatures flex-column align-items-center ">
        <Col
          md={12}
          className="w-100 mt-5 d-flex justify-content-center text_36 RalewayXBold"
        >
          {t("FeaturesTitle")}
          <span className="mx-2 landing_banner_Heading">
            {t("FeaturesSpan")}
          </span>
        </Col>
        <Row className="productSansLight w_40 w-xs-90 px-5  d-flex justify-content-center text_18 text-center">
          {t("FeaturesSubtext")}
        </Row>
        <TilesRow data={MoreFeatures} />
      </Row>
    </>
  );
};

export default MoreWaterMarkFeature;
